(function(root){
'use strict';
const STORE_HOSTS=new Set(['www.inutec-int.com','inutec-int.com']);
function safeProductURL(value){
 try {const u=new URL(value);if(u.protocol!=='https:'||!STORE_HOSTS.has(u.hostname)||!u.pathname.startsWith('/products/')||u.username||u.password)return null;return u.href;}catch{return null;}
}
function safeImageURL(value){
 try {const u=new URL(value);if(u.protocol!=='https:'||u.hostname!=='cdn.shopify.com'||!u.pathname.startsWith('/s/files/')||u.username||u.password)return null;return u.href;}catch{return null;}
}
function normalizePublicProducts(input){
 // Only called from a dedicated public-product presentation contract.
 // Never subscribe to full server-tool payloads or pass customer/account results here.
 if(!input||typeof input!=='object'||!Array.isArray(input.products))return [];
 const seen=new Set(),out=[];
 for(const p of input.products.slice(0,20)){
  if(!p||typeof p!=='object')continue;
  const url=safeProductURL(p.url),title=typeof p.title==='string'?p.title.trim().slice(0,250):'';
  if(!url||!title||seen.has(url))continue;
  seen.add(url);
  const image=(Array.isArray(p.media)?p.media:[]).find(m=>m?.type==='image'&&safeImageURL(m.url));
  out.push({title,url,image:image?safeImageURL(image.url):null});
  if(out.length===10)break;
 }
 return out;
}
function renderPublicProducts(container,input){
 const items=normalizePublicProducts(input);if(!items.length)return 0;
 const block=document.createElement('section');block.className='sa-public-products';block.setAttribute('aria-label','Produkte aus der Shopsuche');
 const heading=document.createElement('h3');heading.textContent='Produkte aus der Shopsuche';block.append(heading);
 const note=document.createElement('p');note.textContent='Suchtreffer – noch keine abschließend geprüfte Empfehlung. Details und aktuelle Preise auf der Produktseite.';block.append(note);
 const grid=document.createElement('div');grid.className='sa-public-products-grid';
 for(const item of items){
  const a=document.createElement('a');a.href=item.url;a.target='_blank';a.rel='noopener noreferrer';a.className='sa-public-product';
  if(item.image){const img=document.createElement('img');img.src=item.image;img.alt=item.title;img.loading='lazy';img.width=180;img.height=130;a.append(img);}
  const title=document.createElement('strong');title.textContent=item.title;a.append(title);
  const label=document.createElement('span');label.textContent='Produkt ansehen ↗';a.append(label);grid.append(a);
 }
 block.append(grid);
 if(input.has_more===true){const more=document.createElement('p');more.textContent='Weitere Suchtreffer vorhanden; diese Auswahl ist nicht vollständig.';block.append(more);}
 container.append(block);return items.length;
}
function handlePublicProducts(container,input){
 try{
  if(input && typeof input.products_json==='string'){
   if(input.products_json.length>30000)return JSON.stringify({status:'rejected',count:0});
   input={products:JSON.parse(input.products_json),has_more:input.has_more===true};
  }
  if(!container||!input||!Array.isArray(input.products)||input.products.length>10)return JSON.stringify({status:'rejected',count:0});
  const count=renderPublicProducts(container,input);
  return JSON.stringify({status:count?'displayed':'rejected',count});
 }catch{return JSON.stringify({status:'unavailable',count:0});}
}
const api={handlePublicProducts,safeProductURL,safeImageURL,normalizePublicProducts,renderPublicProducts};
if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.InutecPublicProducts=api;
})(typeof window!=='undefined'?window:{});
